import script from "./UserDeliveryAddresses.vue?vue&type=script&setup=true&lang=js"
export * from "./UserDeliveryAddresses.vue?vue&type=script&setup=true&lang=js"

import "./style.scss?vue&type=style&index=0&id=381b0184&lang=scss&scoped=true"

import exportComponent from "/builds/strooka-jagaad/strooka-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-381b0184"]])

export default __exports__